module.exports = __webpack_public_path__ + "5118d65fc16760a7f89242c95469cdb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-1.png
// module id = 3236
// module chunks = 0